import girl from "../../assets/UnsubscribeIcon/girl.svg";
import cup from "../../assets/UnsubscribeIcon/cup.svg";
import facebook from "../../assets/UnsubscribeIcon/facebook.svg";
import game from "../../assets/UnsubscribeIcon/game.svg";
import instagram from "../../assets/UnsubscribeIcon/instagram.svg";
import linkedin from "../../assets/UnsubscribeIcon/linkedin.svg";
import LoadingOverlay from "react-loading-overlay-ts";
import { unsubscribeUser } from "./UnsubscribeForm.api";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "context/auth-context";
import {toastrSuccess, toastrWarn } from "./../../lib/toastr";
import { Link } from "react-router-dom";
import { useSubscribe } from "context/Subscribe-context";
import { useTranslation } from "react-i18next";
import { PageHeader } from "components/ui";

export const UnsubscribeForm = () => {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const { setisSubscribe } = useSubscribe();

  const mutation = useMutation(() => unsubscribeUser(auth.email), {
    onSuccess() {
      toastrSuccess(t("Unsubscribe.toastsuccess"));
    },
    onError() {
      toastrWarn(t("Unsubscribe.toasterror"));
    },
  });

  const handleClick = async (e) => {
    e.preventDefault();
    setisSubscribe(0);
    mutation.mutate();
  };

  return (
    <LoadingOverlay
      styles={{
        overlay: (base) => ({
          ...base,
          position: "fixed",
          zIndex: 70,
          background: "rgb(var(--zs-overlay) / 0.45)",
          backdropFilter: "blur(2px)",
        }),
      }}
      active={mutation.isLoading}
      spinner
      text={t("page.Loading")}
    >
      <div className="zs-page zs-page-narrow">
        <PageHeader eyebrow="Settings" title={t("Unsubscribe.heading")} />
        <section className="overflow-hidden zs-card">
          {/* Top Part */}
          <div className="flex flex-col items-center gap-4 px-6 py-8 text-center border-b sm:py-10 bg-primary-soft border-line">
            <img src={girl} alt="" className="w-auto max-h-40"></img>
            <p className="max-w-md text-base font-semibold leading-snug sm:text-lg font-display text-ink">
              {t("Unsubscribe.description")} <br />
              {t("Unsubscribe.descriptionline2")}
            </p>
          </div>
          {/* Bottom Part */}
          <div className="flex flex-col items-center gap-6 px-6 py-8 text-center">
            <div className="flex flex-col gap-1 text-sm text-ink-2 sm:text-base">
              <p className=""> {t("Unsubscribe.paragraph.line1")}</p>
              <p>{t("Unsubscribe.paragraph.line2")}</p>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-2">
              <a href="https://www.facebook.com/zampliasurveys" className="p-1.5 zs-logo-plate rounded-full">
                <img src={facebook} alt="facebook" className="w-7 h-7"></img>
              </a>
              <a className="p-1.5 zs-logo-plate rounded-full">
                <img src={instagram} alt="instagram" className="w-7 h-7"></img>
              </a>
              <a className="p-1.5 zs-logo-plate rounded-full">
                <img src={game} alt="game" className="w-7 h-7"></img>
              </a>
              <a href="https://www.reddit.com/r/zampliasurveys/" className="p-1.5 zs-logo-plate rounded-full">
                <img src={cup} alt="redit" className="w-7 h-7"></img>
              </a>
              <a href="https://www.linkedin.com/company/zamplia/" className="p-1.5 zs-logo-plate rounded-full">
                <img src={linkedin} alt="linkedin" className="w-7 h-7"></img>
              </a>
            </div>
          </div>
          <div className="flex flex-col-reverse gap-2 px-6 py-4 border-t sm:flex-row sm:justify-end border-line bg-surface-2">
            <button className="zs-btn zs-btn-ghost text-danger hover:!text-danger" onClick={handleClick}>
              {t("Unsubscribe.btntext2")}
            </button>
            <Link to={"/Dashboard"} className="block">
              <button className="w-full zs-btn zs-btn-primary sm:w-auto">{t("Unsubscribe.btntext1")}</button>
            </Link>
          </div>
        </section>
      </div>
    </LoadingOverlay>
  );
};
